// Lightweight singleton loader for the Google Maps JS API.
let _promise = null;

export function loadGoogleMaps(apiKey, libraries = "marker") {
    if (_promise) return _promise;
    if (typeof window !== "undefined" && window.google && window.google.maps) {
        _promise = Promise.resolve(window.google);
        return _promise;
    }
    _promise = new Promise((resolve, reject) => {
        if (!apiKey) {
            reject(new Error("Google Maps API key missing"));
            return;
        }
        window.__dwjInitMap = () => {
            resolve(window.google);
            delete window.__dwjInitMap;
        };
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&callback=__dwjInitMap&libraries=${encodeURIComponent(libraries)}&v=weekly&loading=async`;
        script.async = true;
        script.defer = true;
        script.onerror = () => reject(new Error("Google Maps script failed to load"));
        document.head.appendChild(script);
    });
    return _promise;
}
